module.exports = __webpack_public_path__ + "static/media/itesm.a727afc4.png";